import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { QuestionFrame } from 'components/questions'
import { Map, ZoomControl, LegendControl, HazardMapLayer, CenterLineLayer, AddressSearchControl } from 'components/map'
import { useGlobalState } from 'state'
import mapboxgl from 'mapbox-gl'
import { defaltMapPayload } from 'common/config'
import { getHeartrailsAddresses, toHalfWidthNum } from 'common/utils'


export const Q00Map = () => {
  const state = useGlobalState()
  const [marker] = React.useState<mapboxgl.Marker>(new mapboxgl.Marker({draggable: true}))

  React.useEffect(() => {
    if (!state.mapbox) return

    const answer = state.app.getAnswerByKey('map')
    let lngLat = state.mapbox.getCenter()
    if (answer !== null && answer.value.lng && answer.value.lat) {
      lngLat = new mapboxgl.LngLat(answer.value.lng, answer.value.lat)
      state.mapbox.setCenter(lngLat)
    }

    marker
      .setLngLat(lngLat)
      .addTo(state.mapbox)

    marker.on('dragend', () => {
      saveLngLat(marker.getLngLat())
    })

    state.mapbox.on('click', clickMap)

    loadHomeAddress()

    return () => {
      if (state.mapbox) {
        state.mapbox.off('click', clickMap)
      }
    }
  }, [state.mapbox])

  const loadHomeAddress = async () => {
    if (!state.mapbox) return
    const mapInfo = state.app.getAnswerByKey('map')
    if (mapInfo !== null && mapInfo.valid === true) {
      if (mapInfo.value.lng !== defaltMapPayload.center.lng && mapInfo.value.lat !== defaltMapPayload.center.lat) {
        return
      }
    }
    const address = state.app.getAnswer(-1, 6)
    if (address === null || address.value === '') {
      saveLngLat(marker.getLngLat())
      return
    }
    let keyword = address.value.trim()
    keyword = keyword.replace('　', '')
    keyword = keyword.split(' ')[0]
    keyword = toHalfWidthNum(keyword)
    keyword = keyword
      .replace('一丁目', '1丁目')
      .replace('二丁目', '2丁目')
      .replace('三丁目', '3丁目')
      .replace('四丁目', '4丁目')
      .replace('五丁目', '5丁目')
      .replace('六丁目', '6丁目')
      .replace('七丁目', '7丁目')
      .replace('八丁目', '8丁目')
      .replace('九丁目', '9丁目')
      .replace('十丁目', '10丁目')
    const index = keyword.search(/\d/)
    keyword = keyword.slice(0, index)
    const addresses = await getHeartrailsAddresses(keyword)
    if (addresses.length === 0) return
    const lngLat = new mapboxgl.LngLat(addresses[0].lng, addresses[0].lat)
    state.mapbox.setCenter(lngLat)
    marker.setLngLat(lngLat)
    saveLngLat(lngLat)
  }

  const clickMap = (e: mapboxgl.MapMouseEvent) => {
    if (!state.mapbox) return
    const lngLat = e.lngLat
    marker.setLngLat(lngLat)
    saveLngLat(lngLat)
  }

  const saveLngLat = (lngLat: mapboxgl.LngLat) => {
    const data = {
      'lng': String(lngLat.lng),
      'lat': String(lngLat.lat)
    }
    state.app.updateAnswerByKey('map', data, false)
  }

  const getCurrentLocation = () => {
    if (marker === null) return
    navigator.geolocation.getCurrentPosition(
      position => {
        if (!state.mapbox) return
        const lng = position.coords.longitude
        const lat = position.coords.latitude
        const lngLat = new mapboxgl.LngLat(lng, lat)
        state.mapbox.setCenter(lngLat)
        marker.setLngLat(lngLat)
        saveLngLat(lngLat)
      },
      error => {
        console.log(error)
      }
    )
  }

  const moveMakerToCenter = () => {
    if (!state.mapbox) return
    const center = state.mapbox.getCenter()
    marker.setLngLat(center)
    saveLngLat(center)
  }

  return (
    <QuestionFrame q={0}>
      <Typography variant='h6' pt={1}>評価する物件位置をクリックしてください</Typography>

      <Stack
        spacing={2}
        mb={1}
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        width={'100%'}>
        { false && <Button variant='text' size='small' onClick={getCurrentLocation}>現在地へ移動</Button> }
        { false && <Button variant='text' size='small' onClick={moveMakerToCenter}>マーカーを地図中央に配置</Button> }
      </Stack>

      <Box position={'relative'} width={'100%'} height={'calc(100dvh - 400px)'}>
        <Map>
          <HazardMapLayer />
          <CenterLineLayer />

          <Stack sx={{position: 'absolute', zIndex: 1, top: 80, right: 8, pointerEvents: 'none'}} spacing={1}>
            <ZoomControl />
            <LegendControl />
          </Stack>
          <Stack sx={{position: 'absolute', zIndex: 1, top: 8, left: 8}} spacing={1}>
            <AddressSearchControl />
          </Stack>

        </Map>
      </Box>

    </QuestionFrame>
  )
}
